// MercadoriasLayout.jsx
import React, { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import FeedbackModal from '../modals/FeedbackModal';
import { Hourglass } from 'react-loader-spinner';
import { getSuppliers } from '../../services/api';
import Merchinsupplier from '../modals/merchinsupplier'; // Certifique-se do caminho correto

const MercadoriasLayout = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [globalFilter, setGlobalFilter] = useState('');
  const [feedbackVisible, setFeedbackVisible] = useState(false);
  const [feedbackStatus, setFeedbackStatus] = useState(''); // 'loading', 'success', 'error'
  const [feedbackMessage, setFeedbackMessage] = useState('');

  // Estado para abrir a modal de "Dar Entrada" (merchinsupplier)
  const [merchinsupplierOpen, setMerchinsupplierOpen] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);

  useEffect(() => {
    const fetchSuppliers = async () => {
      setLoading(true);
      setFeedbackStatus('loading');
      setFeedbackMessage('Loading suppliers...');
      setFeedbackVisible(true);
      try {
        const response = await getSuppliers();
        setSuppliers(response.data);
        setFeedbackStatus('success');
        setFeedbackMessage('Suppliers loaded successfully!');
      } catch (error) {
        console.error("Erro ao buscar fornecedores:", error);
        setFeedbackStatus('error');
        setFeedbackMessage('Error loading suppliers.');
      }
      setLoading(false);
      setTimeout(() => {
        setFeedbackVisible(false);
      }, 1500);
    };

    fetchSuppliers();
  }, []);

  const openMerchinsupplierModal = (supplier) => {
    setSelectedSupplier(supplier);
    setMerchinsupplierOpen(true);
  };

  const closeMerchinsupplierModal = () => {
    setMerchinsupplierOpen(false);
    setSelectedSupplier(null);
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div>
        <Button 
          icon="pi pi-check" 
          label="Dar Entrada" 
          className="p-button-success p-mr-2"
          onClick={() => openMerchinsupplierModal(rowData)}
        />
        <Button 
          icon="pi pi-info-circle" 
          label="Consultar" 
          className="p-button-info"
          onClick={() => console.log(`Consultar ${rowData.name}`)}
        />
      </div>
    );
  };

  const header = (
    <div className="table-header" style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <InputText 
        type="search" 
        onInput={(e) => setGlobalFilter(e.target.value)} 
        placeholder="Search suppliers" 
        className="p-inputtext-sm" 
      />
    </div>
  );

  return (
    <Card title="Mercadorias">
      <DataTable 
        value={suppliers}
        paginator
        rows={10}
        header={header}
        globalFilter={globalFilter}
        loading={loading}
        emptyMessage="No suppliers found."
      >
        <Column field="name" header="Name" sortable />
        <Column body={actionBodyTemplate} header="Actions" />
      </DataTable>

      <FeedbackModal visible={feedbackVisible}>
        {feedbackStatus === 'loading' && (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Hourglass height="50" width="50" color="#000" ariaLabel="loading" />
            <p>{feedbackMessage}</p>
          </div>
        )}
        {feedbackStatus === 'success' && (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <p>{feedbackMessage}</p>
          </div>
        )}
        {feedbackStatus === 'error' && (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: 'red' }}>
            <p>{feedbackMessage}</p>
          </div>
        )}
      </FeedbackModal>

      {/* Modal para Dar Entrada */}
      {selectedSupplier && merchinsupplierOpen && (
        <Merchinsupplier 
          open={merchinsupplierOpen} 
          onClose={closeMerchinsupplierModal} 
          supplier={selectedSupplier} 
        />
      )}
    </Card>
  );
};

export default MercadoriasLayout;
